.root {
  background-color: var(--avatar-background);
}
